import React from "react";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";

type Props = {
  heading?: string;
  numberOfAppointments: number;
  numberOfHours: number;
  numberOfParticipants?: number;
};

function BaseDocumentation(props: Props) {
  const { heading, numberOfAppointments, numberOfHours, numberOfParticipants } =
    props;

  return (
    <Stack direction="column">
      {heading != null && (
        <Typography component="h3" variant="h6" fontWeight="bold">
          {heading}
        </Typography>
      )}
      <Typography>Anzahl der Termine: {numberOfAppointments}</Typography>
      <Typography>Anzahl der Stunden: {numberOfHours}</Typography>
      {numberOfParticipants != null && (
        <Typography>
          Anzahl der Teilnehmenden: {numberOfParticipants}
        </Typography>
      )}
    </Stack>
  );
}

export default BaseDocumentation;
